// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MediumSquareFilledSvg from "@fishx/icons-svg/es/asn/MediumSquareFilled";
import FishxIcon from '../components/FishxIcon';

var MediumSquareFilled = function MediumSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MediumSquareFilledSvg
  }));
};

MediumSquareFilled.displayName = 'MediumSquareFilled';
export default React.forwardRef(MediumSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MediumSquareFilled.js
// module id = 3108
// module chunks = 0